import React from 'react';
import Img from 'gatsby-image';

import './TextBlock.css';

export default ({ title, text }) => (
    <div className="text-wrapper" key={title}>
        <h3>{title}</h3>
        <div>
            <div dangerouslySetInnerHTML={{ __html: text }} />
        </div>
    </div>
);
